
const metricsMap = () => {
    const metrics_map = {
        placeholder: {label: 'Not Required', spark: (placeholder) => 'nope'},
    };
    return metrics_map
};

export {metricsMap};